<script setup lang="ts">
import {
	ScrollAreaCorner,
	ScrollAreaRoot,
	type ScrollAreaRootProps,
	ScrollAreaViewport,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";
import ScrollBar from "./ScrollBar.vue";

const props = defineProps<
	ScrollAreaRootProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ScrollAreaRoot
		v-bind="delegatedProps"
		:class="twMerge('relative overflow-hidden', props.class)"
	>
		<ScrollAreaViewport class="h-full w-full rounded-[inherit]">
			<slot />
		</ScrollAreaViewport>
		<ScrollBar />
		<ScrollAreaCorner />
	</ScrollAreaRoot>
</template>
